<ng-container
  *ngIf="{
    albaran: albaran,
    carrito: carritoDevolucion$ | async
  } as o"
>
  <div class="Imprimir">
    <div class="tituloInt tituloVentas">
      {{ 'DEVOLUCION_PARCIAL' | translateV2:'CAPITALIZE' }} # {{ o.albaran.TPVId }}/ {{ o.albaran.NumVenta }} ({{
        o.albaran.NumEntradas
      }}
      {{ 'ENTRADAS' | translateV2:'LOWER' }})
    </div>

    <div class="ticket-info localiza-info">
      <div class="inputControl" [formGroup]="busquedaForm">
        <input
          [attr.disabled]="deshabilitarFiltro"
          category="FILTER"
          (focus)="focusValue($event)"
          formControlName="query"
          class="localizador"
          type="text"
          placeholder="{{ 'FILTRAR_NUM_ENTRADAS' | translateV2:'CAPITALIZE' }}"
        />
        <img
          class="svg"
          src="assets/img/icon-search.svg"
          alt="icono busqueda"
        />
        <div class="close">
          <a title="cerrar"
            ><span class="cross"></span><span class="sr-only">{{ 'CERRAR' | translateV2 }}</span></a
          >
        </div>
      </div>
      <div class="onoffswitch-wrapGeneral">
        <div class="onoffswitch-wrap">
          <div class="onoffswitch">
            <input
              #checkAllSwitch
              type="checkbox"
              (change)="checkAllEntradas($event)"
              name="onoffswitch04"
              id="myonoffswitch04"
              class="onoffswitch-checkbox"
              [checked]="deshabilitarFiltro"
            />
            <label class="onoffswitch-label" for="myonoffswitch04"></label>
          </div>
          <label class="onoffswitch-label-text" for="myonoffswitch04"
            >{{ 'DEVOLVER_TODAS' | translateV2 }}</label
          >
        </div>
      </div>
    </div>

    <div class="ResumenResultado">
      <strong>{{ 'TODAS' | translateV2:'CAPITALIZE' }}</strong> {{ 'LAS' | translateV2:'LOWER' }}
      <strong>{{ o.albaran.NumEntradas }}</strong> {{ 'ENTRADAS_LISTADAS' | translateV2:'LOWER' }},
      <span *ngIf="o.carrito && o.carrito.cantidadTotal"
        >{{ o.carrito.cantidadTotal }} {{ 'PRODUCTOS_SELECCIONADOS' | translateV2:'LOWER' }}</span
      >
    </div>

    <div class="Listadoresultado">
      <div class="Header">
        <div>{{ 'ENTRADA' | translateV2 }}</div>
        <div>{{ 'NUMERO' | translateV2 }}</div>
      </div>

      <div class="checkboxStyledWrap">
        <ng-container *ngFor="let item of pagedItems; index as i">
          <div class="checkboxStyled">
            <div class="center">
              <label class="label" for="{{ item.id }}">
                <input
                  [disabled]="item.yaDevuelto"
                  class="label__checkbox"
                  [checked]="isChecked(item)"
                  (change)="checkEntrada($event, item)"
                  type="checkbox"
                  id="{{ item.id }}"
                />

                <span *ngIf="item.yaDevuelto" class="label__check devuelta">
                  <img
                    class="svg"
                    src="assets/img/checkbox-mark.svg"
                    alt="icono checkbox"
                  />
                </span>
                <span *ngIf="!item.yaDevuelto" class="label__check">
                  <img
                    class="svg"
                    src="assets/img/checkbox-mark.svg"
                    alt="icono checkbox"
                  />
                </span>
              </label>
            </div>
            <label class="label__text" for="{{ item.id }}">
              <span class="sub-wrap">
                <span class="sub-tit"
                  >{{ item.itemInfo.NombrePantalla }}
                  <span *ngIf="item.descMotivo || item.descMotivo != ''">
                    ( {{ item.descMotivo }} )
                  </span>
                  <span *ngIf="item.yaDevuelto" style="font-weight:bold">
                    ({{ 'DEVUELTO' | translateV2 }})
                  </span>
                </span>

                <!-- Tickets asociados (equivalente a TicketsListado) -->
                <div class="sub-tit" *ngIf="item.tickets && item.tickets.length">
                  {{ 'TICKETS' | translateV2 }}:
                  <ng-container *ngFor="let t of item.tickets; let last = last">
                    {{ t.NumTicket }}<span *ngIf="!last">, </span>
                  </ng-container>
                </div>

                <!-- Importe total del ticket si viene informado en el item/ticket -->
                <div class="sub-tit" *ngIf="item.ImporteTotalTicket || (item.tickets && item.tickets[0] && item.tickets[0].ImporteTotalTicket)">
                  {{ 'IMPORTE_TOTAL' | translateV2 }}:
                  <span>
                    {{ (item.ImporteTotalTicket || item.tickets[0].ImporteTotalTicket) }}
                  </span>
                </div>

                <div 
                  *ngIf="
                    item.tickets[0].TipoProducto === '1' &&
                    item.tickets[0].hasOwnProperty('EspectaculosImprimir') &&
                      item.tickets[0].EspectaculosImprimir !== null
                  "
                >
                  <div>
                    <span class="sub-tit"
                      >{{ 'TEATRO' | translateV2:'CAPITALIZE' }}:
                      {{ item.tickets[0].EspectaculosImprimir.GrupoRecinto }}
                      - {{ 'ZONA' | translateV2 }}: {{ item.tickets[0].EspectaculosImprimir.Recinto }}
                      - {{ 'ESPECTACULO' | translateV2 }}: {{ item.tickets[0].EspectaculosImprimir.EspectaculoNombre }}
                    </span>
                    <span class="sub-tit"
                      >-
                      {{
                        item.itemInfo.FechaHoraEntrada
                          | fecha: 'YYYY/MM/DD HH:mm:ss':'es-ES'
                      }}
                    </span>
                  </div>
                  <div
                    *ngIf="
                      item.tickets[0].EspectaculosImprimir.Numeradas === '1'
                    "
                  >
                    <span class="sub-tit">
                      {{ 'FILA' | translateV2:'CAPITALIZE' }}:
                      {{ item.tickets[0].EspectaculosImprimir.NumFila }} {{ 'BUTACA' | translateV2:'CAPITALIZE' }}:
                      {{ item.tickets[0].EspectaculosImprimir.NumButaca }}
                    </span>
                  </div>
                </div>
              </span>
              <span class="number">{{ item.numTickets }}</span>
            </label>
          </div>
        </ng-container>
      </div>

      <ul class="pagination">
        <ng-container>
          <li>
            <a (click)="setPage(pager.currentPage - 1)" title="Previo">
              <img
                class="svg"
                src="assets/img/active-arrow.svg"
                alt="icono prev"
              />
            </a>
          </li>
          <li *ngFor="let page of pager.pages">
            <a
              (click)="setPage(page)"
              [ngClass]="{ active: pager.currentPage === page }"
              >{{ page }}</a
            >
          </li>
          <li>
            <a (click)="setPage(pager.currentPage + 1)" title="Próximo">
              <img
                class="svg"
                src="assets/img/active-arrow.svg"
                alt="icono next"
              />
            </a>
          </li>
        </ng-container>
      </ul>
    </div>

    <!--<div>
      {{selectedItems.length }}
      <div *ngIf="selectedItems.length > 0">
        <div class="horariosWrap" *ngFor="let item of o.carrito.entradas">
          <div class="panel panel-info">
            <div class="panel-body">
              <div class="horarios">
                  <div *ngFor="let sesion of albaran.AlbaranRecintos">
                  <div class="Rtable-cell horario-cell" *ngIf="sesion.Periodo && sesion.Periodo == '1' && sesion.ItemId == item.entrada.ItemId"> 
                    <div 
                    [ngClass]="{ 'Rtable-cell--content horario-content': isSelected(transferenciaInput) }"
                    (click) = "seleccionarSesion(sesion)"> {{sesion.FechaEntrada}} </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>-->

    <div class="ButtonWrap">
      <button
        [disabled]="selectedItems.length === 0 || pulsado"
        class="bordeAzulButton imprimir"
        (click)="devolver()"
        title="{{ 'DEVOLVER' | translateV2 }}"
      >
        {{ 'DEVOLVER' | translateV2 }}
        <span *ngIf="o.carrito && o.carrito.cantidadTotal"
          >({{ o.carrito.cantidadTotal }})</span
        >
      </button>
    </div>
  </div>
</ng-container>
